import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  h1,
  > p {
    font-family: AvertaPE;
    font-style: normal;
    font-weight: normal;
  }

  h1 {
    font-size: 24px;
    line-height: 30px;
    letter-spacing: 0.15px;
    color: #1b2852;
    margin-bottom: 11px;
  }

  > p {
    font-size: 16px;
    line-height: 21px;
    letter-spacing: 0.15px;
    color: #69769b;
    margin-bottom: 24px;
  }

  flex: 1;
  flex-direction: column;
  text-align: start;
  padding: 40px 16px;

  .centerButton {
    display: flex;
    justify-content: center;
    margin-top: 44px;
  }
`;

export const ContainerInput = styled.div`
  margin-bottom: 26px;

  .contianerValidation {
    margin-top: 16px;
    margin-left: -10px;
  }
`;

export const ContainerInputsModal = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 23px;
`;

export const ContinarModal = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  padding-bottom: 54px;

  > h4 {
    /* font-family: AvertaPE; */
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.15px;
    color: #1b2852;
    margin-bottom: 24px;
  }

  > p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
    letter-spacing: 0.15px;
    color: #69769b;
    margin-bottom: 36px;
  }

  ::-webkit-input-placeholder {
    text-align: center;
  }

  :-moz-placeholder {
    /* Firefox 18- */
    text-align: center;
  }

  ::-moz-placeholder {
    /* Firefox 19+ */
    text-align: center;
  }

  :-ms-input-placeholder {
    text-align: center;
  }

  button {
    margin-top: 32px;
  }

  .containerButton {
    text-align: center;
  }
`;
